import { formatFace } from '@/services/gestionTiers/formatProduits';
import { PGetAllLigneAnonymeByProduitIdAsync } from '@/api/ligneCommande';

export default async function getDetailProduits(produitIds, dateLigneAA, hash) {
  const response = (await PGetAllLigneAnonymeByProduitIdAsync(hash, {
    query: { dateLigneAA, produitIds },
    maxResultCount: 999999,
  })).data.result.items;
  if (!response.length) return [];
  const panneaux = response.filter(r => !!r.lignesCommande?.length).map((ligne, index) => {
    const panneau = formatFace(ligne);
    panneau.num = index + 1;
    return panneau;
  });

  panneaux.sort((a, b) => {
    const aFictif = a.echeanciers.some(e => e.isEcheancierFictif);
    const bFictif = b.echeanciers.some(e => e.isEcheancierFictif);
    return aFictif - bFictif;
  }).map((ligne, index) => {
    ligne.num = index + 1;
    return ligne;
  });
  return panneaux;
}
